module.exports = __webpack_public_path__ + "assets/63c7365ed8d8d13fd1a87758d2006253.jpg";